export default function canShowCreate(allowCreate, _ref) {
  var _ref$searchTerm = _ref.searchTerm,
      searchTerm = _ref$searchTerm === void 0 ? '' : _ref$searchTerm,
      data = _ref.data,
      dataItems = _ref.dataItems,
      accessors = _ref.accessors;

  var eq = function eq(v) {
    return accessors.text(v).toLowerCase() === searchTerm.toLowerCase();
  }; // if there is an exact match on textFields:
  // "john" => { name: "john" }, don't show


  var hasExtactMatch = function hasExtactMatch() {
    return dataItems && dataItems.some(eq) || data.some(eq);
  };

  return !!((allowCreate === true || allowCreate === 'onFilter' && searchTerm) && !hasExtactMatch());
}